/* eslint-disable */
import axios from "axios";
import qs from 'qs';

// const ajaxUrl = "/admin/";
// const ajaxUrl = "http://192.168.201.146/myhomeland/";
const ajaxUrl = '/' + location.pathname.split('/')[1];
const Ajax = axios.create({
   baseURL: 'https://mljy.softtekchina.com/myhomeland/',
  //baseURL: 'https://mljy.mdtwechat.com/myhomeland/',
  timeout: 30000
});

const API = {
  /*
   * 获取轮播图列表
   */
  getBannerList () {
    return Ajax.get('/carousel');
  },

  /*
   * 获取栏目列表
   */
  getColumnList (resource, data) {
    return Ajax.get('/channel');
  },

  /*
   *  消息箱已读
   * @params channelid 子频道接口里的channelid
   */
  read (channelid) {
    return Ajax.post('/read', {channelid: channelid});
  },

  /*
   *  所有消息阅读状态
   * @params channelid 子频道接口里的channelid
   */
  readStatus () {
    return Ajax.get('/box/num');
  },

  /*
   *  消息箱list
   * @params data.page 页码从1开始
   * @params data.page_size 一页展示多少条数据 默认10
   */
  getInfoList (data) {
    return Ajax.get('/box', {
        params: data,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    });
  },

  /*
   *  消息箱info
   * @params data.page 页码从1开始
   * @params data.page_size 一页展示多少条数据 默认10
   */
  getInfoBox (id) {
    return Ajax.get(`/box/${id}`);
  },

  /*
   *  消息箱info
   * @params data.page 页码从1开始
   * @params data.page_size 一页展示多少条数据 默认10
   */
  getInfoLibrary (id) {
    return Ajax.get(`/library/${id}`);
  },

  /*
   *  图文点赞
   * @params data.page 页码从1开始
   * @params data.page_size 一页展示多少条数据 默认10
   */
  like (id) {
    return Ajax.post(`/library/like`, {id: id});
  },

  /*
   *  图文浏览时长
   * @params data.id 图文id
   * @params data.duration 时长 格式：00:00:00
   */
  duration (data) {
    return Ajax.post(`/library/duration`, data);
  },

  /*
   *  获取微信jssdk
   */
  getWechatAssign () {
    return Ajax.get('/js/sdk');
  },

  /*
   *  获取ee报销订单列表
   * @params data.id 搜索id
   * @params data.start_time 开始时间
   * @params data.end_time 结束时间
   */
  getReportList (data) {
    return Ajax.get(`/report/list`, {
        params: data,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    });
  },

  // 获取消息列表
  getMsgList (unread = 0, page = 1, pageSize = 10) {
    return Ajax.get(`/msg/list?unread=${unread}&page=${page}&pageSize=${pageSize}`);
  },

  // 获取消息详情
  getMsgInfo (id) {
    return Ajax.get(`/msg/info?id=${id}`);
  },

  // 消息已读
  readMsg (id) {
    return Ajax.get(`/msg/read?id=${id}`);
  },
}

export default API;
